import React from "react";
import { Button, Image } from "react-bootstrap";
import * as permissions from '../../constants/permissions';

const renderHead = () => (<thead>
    <tr>
        <td>Id</td>
        <td>Название</td>
        <td>Заголовок</td>
        <td>Описание</td>
        <td>Активна</td>
        <td>Иконка</td>
        <td></td>
    </tr>
</thead>);

let CategoriesTable = class extends React.Component {
    _editClick(service) {
        this.props.editClick(service);
    }

    render() {
        const { entities: services } = this.props;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);

        return (<table className='table table-hover'>
            {renderHead()}
            <tbody>
                {services && services.map(s => {
                    const onEditClick = this._editClick.bind(this, s);
                    return (
                        <tr key={s.Id}>
                            <td>{s.Id}</td>
                            <td>{s.Name}</td>
                            <td>{s.Title}</td>
                            <td>{s.Description}</td>
                            <td>{s.IsActive ? 'Да' : 'Нет'}</td>
                            <td><Image src={`api/services/categories/${s.Id}/image?t=${new Date().getTime()}`} height='35px' /></td>
                            <td>
                                <Button disabled={isReadOnly} onClick={onEditClick}>Редактировать</Button>
                            </td>
                        </tr>);
                })}
            </tbody>
        </table>);

    }
};

export default CategoriesTable;


// WEBPACK FOOTER //
// ./src/components/services/CategoriesTable.jsx